// extracted by mini-css-extract-plugin
var _1 = "_pPAhc";
export { _1 as "brDataGrid" }
